import localStorage from './localStorage.js';
import sessionStorage from './sessionStorage.js';
import memCache from './memCache.js';
import redux from './redux.js';

const stores = { localStorage, sessionStorage, redux, memCache };
const GeckoStore = {
  ...stores,
  get(type, key) {
    return new Promise((resolve) => resolve()).then(() => this[type].get(key));
  },
  set(type, key, value) {
    return new Promise((resolve) => resolve()).then(() =>
      this[type].set(key, value)
    );
  },
};

export default GeckoStore;
